module.exports = __webpack_public_path__ + "img/symbol_1.a757fc34.png";